// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TJ2C3iLZKRYAodygPWp4 {
  margin-top: 1.75rem;
  margin-bottom: 1.75rem;
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  font-family: Noto Sans !important;
}

@media (min-width: 1024px) {

  .TJ2C3iLZKRYAodygPWp4 {
    margin-top: 0.75rem;
    margin-bottom: 0.75rem;
  }
}

.Yu0ak3zo2G8eZESbEe5C {
  margin-bottom: 1.25rem;
  display: flex;
  height: 145px;
  width: 145px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  --tw-bg-opacity: 1;
  background-color: rgb(226 232 240 / var(--tw-bg-opacity, 1));
}

@media (min-width: 1024px) {

  .Yu0ak3zo2G8eZESbEe5C {
    margin-bottom: 0.5rem;
    height: 4rem;
    width: 4rem;
  }
}

.lkN8Ueurps_0RSeih4LR {
  margin-top: 0.75rem;
  font-size: 34px;
  font-weight: 700;
}

@media (min-width: 1024px) {

  .lkN8Ueurps_0RSeih4LR {
    margin-top: 0.75rem;
    font-size: 1.125rem;
    line-height: 1.75rem;
  }
}
.UFs_gilS0KkR6eWK96NE {
  font-size: 34px;
  font-weight: 700;
}
@media (min-width: 1024px) {

  .UFs_gilS0KkR6eWK96NE {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }
}
.BNP2hY_U_6GXoAFdpwD1 {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}

.QkmNkSGZNVSeObqQHymt {
  --tw-bg-opacity: 1;
  background-color: rgb(3 120 209 / var(--tw-bg-opacity, 1));
  padding: 2.25rem;
  font-size: 1.875rem;
  line-height: 2.25rem;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

@media (min-width: 1024px) {

  .QkmNkSGZNVSeObqQHymt {
    padding: 1rem;
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
}
.QkmNkSGZNVSeObqQHymt:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(3 120 209 / var(--tw-bg-opacity, 1)) !important;
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important;
}

.JDKQqfNjFJcu2EDRys_A {
  display: flex;
  width: 100%;
  justify-content: space-evenly;
  gap: 1.25rem;
}

@media (min-width: 1024px) {

  .JDKQqfNjFJcu2EDRys_A {
    justify-content: center;
  }
}
.XirqtrbUmPZkkJH3NHuM {
  margin-top: 2rem;
  margin-bottom: 2rem;
  width: 13rem;
}
@media (min-width: 1024px) {

  .XirqtrbUmPZkkJH3NHuM {
    margin-top: 0.75rem;
    margin-bottom: 0.75rem;
    width: 5rem;
  }
}
.hyu968cAnj2CL44rNrk6 .RtClfBx9UvcYk1io34ym {
  width: 90% !important;
  max-width: 900px;
}

@media (min-width: 768px) {
  .hyu968cAnj2CL44rNrk6.RtClfBx9UvcYk1io34ym {
    width: 90% !important;
  }
}

@media (min-width: 1200px) {
  .hyu968cAnj2CL44rNrk6 .RtClfBx9UvcYk1io34ym {
    width: 50% !important;
  }
}

.tnigxCMJDI32Fuh_PObe {
  margin: auto;
  margin-top: 0.5rem;
  height: 62px;
  width: 90%;
  border-radius: 5px;
  border-style: none;
  --tw-bg-opacity: 1;
  background-color: rgb(3 120 209 / var(--tw-bg-opacity, 1));
  font-size: 1.5rem;
  line-height: 2rem;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

@media (min-width: 1024px) {

  .tnigxCMJDI32Fuh_PObe {
    height: 42px;
    width: -moz-fit-content;
    width: fit-content;
    font-size: 1rem;
    line-height: 1.5rem;
  }
}

.tnigxCMJDI32Fuh_PObe:hover,
.tnigxCMJDI32Fuh_PObe:focus,
.tnigxCMJDI32Fuh_PObe:active {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(3 120 209 / var(--tw-bg-opacity, 1)) !important;
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important;
}

.o5VqxfCSLPSuEi1Soau0 {
  font-size: 4.5rem;
  line-height: 1;
}

@media (min-width: 1024px) {

  .o5VqxfCSLPSuEi1Soau0 {
    font-size: 1.5rem;
    line-height: 2rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/MykadModal/MykadModal.module.css"],"names":[],"mappings":"AACE;EAAA,mBAAuF;EAAvF,sBAAuF;EAAvF,aAAuF;EAAvF,WAAuF;EAAvF,sBAAuF;EAAvF,mBAAuF;EAAvF,uBAAuF;EAAvF,SAAuF;EAAvF;AAAuF;;AAAvF;;EAAA;IAAA,mBAAuF;IAAvF;EAAuF;AAAA;;AAIvF;EAAA,sBAA2H;EAA3H,aAA2H;EAA3H,aAA2H;EAA3H,YAA2H;EAA3H,sBAA2H;EAA3H,mBAA2H;EAA3H,uBAA2H;EAA3H,qBAA2H;EAA3H,kBAA2H;EAA3H;AAA2H;;AAA3H;;EAAA;IAAA,qBAA2H;IAA3H,YAA2H;IAA3H;EAA2H;AAAA;;AAI3H;EAAA,mBAAqD;EAArD,eAAqD;EAArD;AAAqD;;AAArD;;EAAA;IAAA,mBAAqD;IAArD,mBAAqD;IAArD;EAAqD;AAAA;AAGrD;EAAA,eAAuC;EAAvC;AAAuC;AAAvC;;EAAA;IAAA,mBAAuC;IAAvC;EAAuC;AAAA;AAGvC;EAAA,oBAAmB;EAAnB;AAAmB;;AAInB;EAAA,kBAA2D;EAA3D,0DAA2D;EAA3D,gBAA2D;EAA3D,mBAA2D;EAA3D,oBAA2D;EAA3D,oBAA2D;EAA3D;AAA2D;;AAA3D;;EAAA;IAAA,aAA2D;IAA3D,mBAA2D;IAA3D;EAA2D;AAAA;AAG3D;EAAA,6BAA8B;EAA9B,qEAA8B;EAA9B,+BAA8B;EAA9B;AAA8B;;AAI9B;EAAA,aAAyD;EAAzD,WAAyD;EAAzD,6BAAyD;EAAzD;AAAyD;;AAAzD;;EAAA;IAAA;EAAyD;AAAA;AAGzD;EAAA,gBAAgC;EAAhC,mBAAgC;EAAhC;AAAgC;AAAhC;;EAAA;IAAA,mBAAgC;IAAhC,sBAAgC;IAAhC;EAAgC;AAAA;AAElC;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,qBAAqB;EACvB;AACF;;AAGE;EAAA,YAA4I;EAA5I,kBAA4I;EAA5I,YAA4I;EAA5I,UAA4I;EAA5I,kBAA4I;EAA5I,kBAA4I;EAA5I,kBAA4I;EAA5I,0DAA4I;EAA5I,iBAA4I;EAA5I,iBAA4I;EAA5I,gBAA4I;EAA5I,oBAA4I;EAA5I;AAA4I;;AAA5I;;EAAA;IAAA,YAA4I;IAA5I,uBAA4I;IAA5I,kBAA4I;IAA5I,eAA4I;IAA5I;EAA4I;AAAA;;AAM5I;;;EAAA,6BAA8B;EAA9B,qEAA8B;EAA9B,+BAA8B;EAA9B;AAA8B;;AAI9B;EAAA,iBAA2B;EAA3B;AAA2B;;AAA3B;;EAAA;IAAA,iBAA2B;IAA3B;EAA2B;AAAA","sourcesContent":[".modalContent {\n  @apply flex flex-col w-full items-center gap-4  justify-center my-7 lg:my-3 !font-inter;\n}\n\n.iconWrapper {\n  @apply rounded-full bg-slate-200 h-[145px] lg:h-16 w-[145px] lg:w-16 flex flex-col items-center justify-center mb-5 lg:mb-2;\n}\n\n.modalText {\n  @apply font-bold text-[34px] lg:text-lg  mt-3 lg:mt-3;\n}\n.modalTextForFinger {\n  @apply font-bold text-[34px] lg:text-lg;\n}\n.noResponseText {\n  @apply text-red-500;\n}\n\n.primaryButton {\n  @apply bg-primary text-white text-3xl lg:text-sm p-9 lg:p-4;\n}\n.primaryButton:hover {\n  @apply !bg-primary !text-white;\n}\n\n.fingerButtonContainer {\n  @apply flex w-full justify-evenly lg:justify-center gap-5;\n}\n.scanImage {\n  @apply my-8 lg:my-3 w-52 lg:w-20;\n}\n.responsiveModal .ant-modal {\n  width: 90% !important;\n  max-width: 900px;\n}\n\n@media (min-width: 768px) {\n  .responsiveModal.ant-modal {\n    width: 90% !important;\n  }\n}\n\n@media (min-width: 1200px) {\n  .responsiveModal .ant-modal {\n    width: 50% !important;\n  }\n}\n\n.connectButton {\n  @apply h-[62px] lg:h-[42px] rounded-[5px] text-white font-subtitle text-2xl lg:text-base border-none bg-primary w-[90%] lg:w-fit m-auto mt-2;\n}\n\n.connectButton:hover,\n.connectButton:focus,\n.connectButton:active {\n  @apply !bg-primary !text-white;\n}\n\n.scanOutlined {\n  @apply text-7xl lg:text-2xl;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalContent": `TJ2C3iLZKRYAodygPWp4`,
	"iconWrapper": `Yu0ak3zo2G8eZESbEe5C`,
	"modalText": `lkN8Ueurps_0RSeih4LR`,
	"modalTextForFinger": `UFs_gilS0KkR6eWK96NE`,
	"noResponseText": `BNP2hY_U_6GXoAFdpwD1`,
	"primaryButton": `QkmNkSGZNVSeObqQHymt`,
	"fingerButtonContainer": `JDKQqfNjFJcu2EDRys_A`,
	"scanImage": `XirqtrbUmPZkkJH3NHuM`,
	"responsiveModal": `hyu968cAnj2CL44rNrk6`,
	"ant-modal": `RtClfBx9UvcYk1io34ym`,
	"connectButton": `tnigxCMJDI32Fuh_PObe`,
	"scanOutlined": `o5VqxfCSLPSuEi1Soau0`
};
export default ___CSS_LOADER_EXPORT___;
